import { Icon } from '@components/ui/Icon/Icon';
import { AppRoutes } from '@types';
import clsx from 'clsx';

import { SidebarEntry } from '../Sidebar/Sidebar.mocks';

import styles from './Navbar.module.scss';

export const getProfileLinks = (logout: () => void): SidebarEntry[] => [
  {
    href: AppRoutes.userProfile,
    onClick: () => {},
    label: 'User profile',
    icon: (
      <Icon
        name="edit"
        className={clsx(styles.icon)}
        style={{ fontSize: 20 }}
      />
    ),
  },
  {
    href: AppRoutes.login,
    onClick: logout,
    label: 'Logout',
    icon: (
      <Icon
        name="logout"
        className={clsx(styles.darkIcon)}
        style={{ fontSize: 20, rotate: '180deg' }}
      />
    ),
  },
];
